let storage = new Map();

export {
    storage,
};